import React, { FunctionComponent } from 'react';
import { ICloudProvider } from '../types';
import StyledImageButton from '../../../../shared/components/molecules/ImageButton';
import { ProviderName } from '../../../../Quotes/types/store';
import { logoForCloudProvider } from 'Quotes/QuoteBuilder/components/Price/components/CloudProvider';

interface ICloudProviderCell {
  className?: string;
  provider: ICloudProvider;
  selectedProviderName?: ProviderName;
  onClick(cloudProvider: ICloudProvider): void;
  readonly?: boolean;
}

const CloudProviderCell: FunctionComponent<React.PropsWithChildren<ICloudProviderCell>> = ({
  provider,
  onClick,
  selectedProviderName,
  readonly,
}) => {
  const name = provider.attributes.name;

  const isSelected = () => {
    return provider.attributes.name === selectedProviderName;
  };

  return (
    <StyledImageButton
      selected={isSelected()}
      description={name}
      disabled={readonly}
      src={logoForCloudProvider(name)}
      onClick={() => onClick(provider)}
    />
  );
};

export default CloudProviderCell;
